import type { ReactElement } from "react";
import type { PeriodSummary } from "@/pages/human-resources/time-management/business/analysis/PeriodSummary.ts";
import IndicatorItem from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/indicator-grid/IndicatorItem.tsx";
import "./IndicatorGrid.scss";
import { PERIOD_SUMMARY_INDICATORS_KEYS } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/model/PeriodSummaryIndicatorsList.ts";

interface Props {
  summary: PeriodSummary;
}

export default function IndicatorGrid({ summary }: Props): ReactElement {
  return (
    <div className="day-summary-indicator-grid">
      {PERIOD_SUMMARY_INDICATORS_KEYS.map((key) => {
        return <IndicatorItem key={key} summary={summary} indicatorKey={key} />;
      })}
    </div>
  );
}
